export const tempUnit: { [key: number]: string } = {
    0: 'F',
    1: 'C'
};
export const tempUnitIds: string[] = Object.keys(tempUnit);
export const defaultTempUnit: number = 1;